import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import {
  convertStraight,
  convertThenFormat,
  convertTimeRangeHHMMSS,
  formatDateTimezon,
} from "../../common-data/Converts";
import DashboardCard from "../../../pages/home/common/DashboardCard";
import ProspectListingsMobile from "./ProspectListingsMobile";
import { getCardLabel, getCardValue } from "./ProspectStats";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import MemberCheckinLogs from "../../pt-trials/common/MemberCheckinLogs";

const PTProspectListings = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  activeCardIndex,
  setActiveCardIndex,
  tableRef,
  mobileTableRef,
  handleOnClickBtn,
  selectedTab,
  handleTabSelect,
  setModValues,
}) => {
  const {
    ptProspectsLists,
    ptProspectsLoading,
    ptProspectsError,

    ptProspectsStats,
    ptProspectsStatsLoading,
    ptProspectsStatsError
  } = useSelector((state) => state.prospects);

  const iniPTDatas = {
    pagination: [],
    allData: [],
    statsData: {},
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const iniClickValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
  };
  const [clickValues, setClickValues] = useState(iniClickValues);

  function onCloseModal() {
    setClickValues(iniClickValues);
  }

  const handleCardClick = (key, index) => {
    setActiveCardIndex((prevIndex) => (prevIndex === index ? null : index));

    tableRef?.current?.scrollIntoView({ behavior: "smooth" });
    mobileTableRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (!ptProspectsStatsError && !ptProspectsStatsLoading && ptProspectsStats?.status) {
      setAllDatas((prevs) => ({
        ...prevs,
        statsData: ptProspectsStats,
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        statsData: {},
      }));
    }
  }, [ptProspectsStats, ptProspectsStatsError, ptProspectsStatsLoading]);

  useEffect(() => {
    if (
      !ptProspectsError &&
      !ptProspectsLoading &&
      ptProspectsLists?.status &&
      ptProspectsLists?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: ptProspectsLists.data,
        pagination:
          ptProspectsLists?.pagination?.length > 0
            ? ptProspectsLists.pagination
            : [],
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        pagination: [],
        allData: [],
      }));
    }
  }, [ptProspectsLists, ptProspectsError, ptProspectsLoading]);

  const tbColumns = [
    {
      dataField: "user_id",
      text: "Member",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth100 link"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "member_info",
                rowData: row,
              }))
            }
          >
            {row?.name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "gym_id",
      text: "gym name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "trainer_id",
      text: "Trainer",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.trainer_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.trainer_mobile || ""}
              <br />
              {row?.trainer_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "last_checkin",
      text: "Member Last Checkin",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth150 link"
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                userId: row?.user_id,
                isModOpen: true,
                cardName: "member_checkin_details",
                sendableStatsQPs: `&start_date=${
                  row?.last_checkin || ""
                }&end_date=${row?.last_checkin || ""}`,
              }))
            }
          >
            {convertStraight(row?.last_checkin) || "-"}
            <br />
            {convertTimeRangeHHMMSS(row?.checkin_time) || ""}
            <br />
            {row?.last_checkin_days_ago
              ? `(${row.last_checkin_days_ago?.replace(/_/g, " ")})`
              : ""}
          </span>
        );
      },
    },
    {
      dataField: "trainer_last_checkin",
      text: "trainer Last Checkin",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth150 link"
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                userId: row?.trainer_id,
                isModOpen: true,
                cardName: "trainer_checkin_details",
                sendableStatsQPs: `&start_date=${
                  row?.trainer_last_checkin || ""
                }&end_date=${row?.trainer_last_checkin || ""}`,
              }))
            }
          >
            {convertStraight(row?.trainer_last_checkin) || "-"}
            <br />
            {convertTimeRangeHHMMSS(row?.trainer_checkin_time) || ""}
            <br />
            {row?.trainer_last_checkin_days_ago
              ? `(${row.trainer_last_checkin_days_ago?.replace(/_/g, " ")})`
              : ""}
          </span>
        );
      },
    },
    {
      dataField: "prospect_status",
      text: "prospect status",
      formatter: (cell, row) => {
        const planStatus = row?.prospect_status
          ?.replace(/ /g, "_")
          ?.toLowerCase();

        return (
          <>
            <span
              className="tb-data minWidth150 withPadding borderRdius27"
              style={{
                background: planStatus === "converted" ? "#379C00" : "#D90000",
                color: "#fff",
              }}
            >
              {row?.prospect_status || "NA"}
            </span>

            <br />

            {planStatus === "converted" && row?.prospect_converted_value && (
              <span className="tb-data">
                <small>
                  (₹{convertThenFormat(row.prospect_converted_value || 0)} /{" "}
                  {row?.converted_date
                    ? convertStraight(row.converted_date)
                    : ""}
                  )
                </small>
              </span>
            )}
          </>
        );
      },
    },
    {
      dataField: "current_plan_status",
      text: "plan status",
      formatter: (cell, row) => {
        const planStatus = row?.current_plan_status
          ?.replace(/ /g, "_")
          ?.toLowerCase();

        return (
          <>
            <span
              className={`tb-data minWidth150 ${
                planStatus ? "withPadding borderRdius27" : ""
              }`}
              style={{
                background: planStatus
                  ? planStatus === "active"
                    ? "#379C00"
                    : "#D90000"
                  : "",
                color: planStatus ? "#fff" : "",
              }}
            >
              {row?.current_plan_status || "NA"}
            </span>

            {(row?.subscription_expiry_days ||
              row?.subscription_expiry_days === 0) && (
              <>
                <br />

                <span className="tb-data">
                  <small>({row?.subscription_expiry_days || "-"})</small>
                </span>
              </>
            )}
          </>
        );
      },
    },
    {
      dataField: "prospect_value",
      text: "prospect value",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.prospect_value || 0)}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "expected_closure_date",
      text: "expected closure date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.expected_closure_date
              ? convertStraight(row.expected_closure_date)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() =>
              handleOnClickBtn("one_time_closure_date_update", row)
            }
            disabled={row?.one_time_update ? false : true}
            style={{
              opacity: row?.one_time_update ? 1 : 0.5,
              cursor: row?.one_time_update ? "pointer" : "not-allowed",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M3.62891 17.3603V20.3254C3.62891 20.5985 3.84349 20.8131 4.1166 20.8131H7.08175C7.20855 20.8131 7.33535 20.7643 7.42313 20.6668L18.0743 10.0254L14.4166 6.36775L3.77521 17.0091C3.67768 17.1067 3.62891 17.2237 3.62891 17.3603ZM20.9029 7.19682C20.9933 7.10658 21.065 6.9994 21.114 6.88141C21.1629 6.76341 21.1881 6.63692 21.1881 6.50918C21.1881 6.38143 21.1629 6.25495 21.114 6.13695C21.065 6.01896 20.9933 5.91177 20.9029 5.82154L18.6205 3.53915C18.5302 3.44873 18.4231 3.37699 18.3051 3.32805C18.1871 3.2791 18.0606 3.25391 17.9328 3.25391C17.8051 3.25391 17.6786 3.2791 17.5606 3.32805C17.4426 3.37699 17.3354 3.44873 17.2452 3.53915L15.4603 5.32409L19.1179 8.98176L20.9029 7.19682Z"
                fill="url(#paint0_linear_14023_4477)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_14023_4477"
                  x1="3.62891"
                  y1="11.6344"
                  x2="21.1881"
                  y2="11.6344"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.0447915" stopColor="#B4000B" />
                  <stop offset="1" stopColor="#DD0000" />
                </linearGradient>
              </defs>
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Edit Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer`}>
          <ModalHeadAndClose
            title={`${
              clickValues.cardName === "edit"
                ? ""
                : clickValues.cardName?.replace(/_/g, " ")
            }`}
            onClose={onCloseModal}
          />

          {clickValues.cardName === "member_checkin_details" ||
          clickValues.cardName === "trainer_checkin_details" ? (
            <MemberCheckinLogs
              clickValues={clickValues}
              sendableStatsQPs={clickValues.sendableStatsQPs}
              from={"tme"}
            />
          ) : null}
        </div>
      </Modal>

      {ptProspectsStatsLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="cards-container cards-grid-container lead-cards grid-4 mt-2rem">
          {allDatas?.statsData?.data &&
            Object.entries(allDatas.statsData.data).map(
              ([key, value], index) => (
                <DashboardCard
                  key={key}
                  tagName={key}
                  cardLabel={getCardLabel(key)}
                  value={getCardValue(
                    key,
                    value,
                    key === "total"
                      ? allDatas.statsData?.prospect_type_values?.total_value
                      : key === "prospect_added_today"
                      ? allDatas.statsData?.prospect_type_values
                          ?.prospect_added_today_value
                      : key === "pending_prospect"
                      ? allDatas.statsData?.prospect_type_values
                          ?.pending_prospect_value
                      : key === "converted_prospect"
                      ? allDatas.statsData?.prospect_type_values
                          ?.converted_prospect_value
                      : key === "converted_prospect_today"
                      ? allDatas.statsData?.prospect_type_values
                          ?.converted_prospect_value_today
                      : key === "expected_closure_today"
                      ? allDatas.statsData?.prospect_type_values
                          ?.expected_closure_today_value
                      : key === "expired_prospect"
                      ? allDatas.statsData?.prospect_type_values
                          ?.expired_prospect_value
                      : 0
                  )}
                  onClickCard={handleCardClick}
                  cardIndex={index}
                  isActiveCard={activeCardIndex === key}
                  isCardClickable={true}
                  isProspect={true}
                />
              )
            )}
        </div>
      )}

      <div className="fullWidthFlexCenter tabsContainer flexStart bgTransParent tmeTabs">
        <Tabs selectedIndex={selectedTab} onSelect={handleTabSelect}>
          <TabList>
            <Tab>active plan prospects</Tab>
            <Tab>expired plan prospects</Tab>
          </TabList>

          <TabPanel>
            <div
              className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table mt30"
              ref={tableRef}
            >
              {ptProspectsLoading ? (
                <ReactVortoxSpinner />
              ) : (
                <PaymentLinkTable
                  tableData={allDatas.allData}
                  tableColumns={tbColumns}
                  tablePagination={allDatas.pagination}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                  isFirstColSticky={true}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                />
              )}
            </div>

            <div
              className="lead-logs-card-container only-mobile"
              ref={mobileTableRef}
            >
              <ProspectListingsMobile
                tableData={allDatas.allData}
                tablePagination={allDatas.pagination}
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
                loading={ptProspectsLoading}
                setModValues={setModValues}
              />
            </div>
          </TabPanel>
          <TabPanel>
            <div
              className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table mt30"
              ref={tableRef}
            >
              {ptProspectsLoading ? (
                <ReactVortoxSpinner />
              ) : (
                <PaymentLinkTable
                  tableData={allDatas.allData}
                  tableColumns={tbColumns}
                  tablePagination={allDatas.pagination}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                  isFirstColSticky={true}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                />
              )}
            </div>

            <div
              className="lead-logs-card-container only-mobile"
              ref={mobileTableRef}
            >
              <ProspectListingsMobile
                tableData={allDatas.allData}
                tablePagination={allDatas.pagination}
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
                loading={ptProspectsLoading}
                setModValues={setModValues}
              />
            </div>
          </TabPanel>
        </Tabs>
      </div>
    </>
  );
};

export default PTProspectListings;
